export class ArtestTopBarCatalogButtonComponent {
    
    static name = "artestTopBarCatalogButtonComponent";

    static selector = "artest-top-bar-catalog-button-component";

    static asAjsComponent() {
        return {
            template: ArtestTopBarCatalogButtonComponent.template,
            controller: ArtestTopBarCatalogButtonComponent
        };
    }

    static template = `
        <div ng-if="enabled">
            <span>{{ 'Content catalog' | translate }}<span>
        </div>
    `;

	catalogs_length = 0;

	enabled = false;

    static $inject = [ "$scope", "$element", "gameSceneService", "catalogsService" ];

    constructor( $scope, $element, gameSceneService, catalogsService ) {

		this.$scope = $scope;
		this.gameSceneService = gameSceneService;

        let link_elem = $element.parent();

        let onClick = event => {
			if (this.enabled) {
            	catalogsService.openCatalogViewer();
			}
        };

        link_elem.on( "click", onClick );

        $scope.$on( "$destory", () => {
            link_elem.off( "click", onClick );
        });

		$scope.$watch(() => {
			let { arrangement } = gameSceneService;
			let catalogs = arrangement && catalogsService.solveCatalogs( arrangement );
			return catalogs && catalogs.length || 0;
		}, catalogs_length => {
			this.catalogs_length = catalogs_length;
			this.refresh();
		});

		$scope.$watch(() => {
			return this.gameSceneService.inEditor();
		}, () => {
			this.refresh();
		});
    }

	refresh() {
		if (this.gameSceneService.inEditor()) {
			if (!this.enabled) this.enable();
		} else {
			if (!this.enabled && this.catalogs_length) {
				this.enable();
			} else if (this.enabled && !this.catalogs_length) {
				this.disable();
			}
		}
	}

	enable() {
		this.$scope.enabled = this.enabled = true;
	}

	disable() {
		this.$scope.enabled = this.enabled = false;
	}
}
